import ModalView from 'react-modal';
import { useNotification } from '../../hooks/useNotification';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import './Notification.scss';

const customStyles = {
    overlay: {
        backgroundColor: '#000F0880',
        display: 'flex',
        alignContent: 'center',
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        margin: 'auto',
        padding: '24px',
        transform: 'translate(-50%, -50%)',
        borderRadius: '16px',
    },
};

/**
 * Muestra una notificación genérica al usuario
 */
const Notification = () => {

    const { isVisible, type, title, message } = useSelector((state: RootState) => state.notification);
    const { hiddeNotification } = useNotification();

    /**
     * Actualiza el redux para cerrar el modal y reestablecer los valores
     */
    const closeModal = () => {
        hiddeNotification();
    };

    return (
        <ModalView isOpen={isVisible} style={customStyles} ariaHideApp={false}>
            <div className='notification-container'>
                <div onClick={() => closeModal()} className='header close'>
                    <img src={`/img/icons/close.svg`} alt='close' />
                </div>
                <div className={`content ${type}`}>
                    <div className={`icon ${type}`}>
                        <img src={`/img/icons/${type}.svg`} alt='close' />
                    </div>
                    <h3>{title}</h3>
                    <p>{message}</p>
                </div>
                <button className={`primary ${type}`} onClick={() => closeModal()}>Continuar</button>
            </div>
        </ModalView>
    );
};

export default Notification;
